import { CustomizationContext, CustomizationProvider } from '@faceup/ui'
import { UiBaseProvider } from '@faceup/ui-base'
import { DEFAULT_LANGUAGE, languageEnumToBasename } from '@faceup/utils'
import { Suspense, useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import AppProviders from './AppProviders'
import { FullScreenLoader } from './Components/FullScreenLoader'
import { LanguageContext } from './Contexts/LanguageContext'
import { LanguageProvider } from './Contexts/LanguageProvider'
import LayoutProvider from './Contexts/LayoutProvider'
import ReportFormProvider from './Contexts/ReportFormProvider'
import ReportSourceProvider from './Contexts/ReportSourceProvider'
import UserProvider from './Contexts/UserProvider'
import CustomApolloProvider from './CustomApolloProvider'
import AppRouter from './Pages/AppRouter'
import OTAUpdate from './utils/OTAUpdate'

const App = () => {
  useEffect(() => {
    OTAUpdate()
  }, [])

  return (
    <LayoutProvider>
      <CustomizationProvider>
        <LanguageProvider>
          <UserProvider>
            {/* UiBaseProvider is here so that notifications on GrahpQL errors inside CustomApolloProvider work correctly
                   UiBaseProvider is replaced deeper in the three with correct props */}
            <UiBaseProvider direction='ltr' locale={undefined}>
              <LanguageContext.Consumer>
                {({ language, messages, direction, antLocale }) => (
                  <ReportFormProvider>
                    <IntlProvider
                      locale={languageEnumToBasename(language ?? DEFAULT_LANGUAGE)}
                      key={language}
                      messages={messages}
                      onError={() => {
                        // Ignore errors
                      }}
                    >
                      <CustomizationContext.Consumer>
                        {({ colors: { primaryColor } }) => (
                          <CustomApolloProvider>
                            <ReportSourceProvider>
                              <AppProviders
                                direction={direction}
                                primaryColor={primaryColor}
                                antLocale={antLocale}
                              >
                                <Suspense fallback={<FullScreenLoader />}>
                                  <AppRouter />
                                </Suspense>
                              </AppProviders>
                            </ReportSourceProvider>
                          </CustomApolloProvider>
                        )}
                      </CustomizationContext.Consumer>
                    </IntlProvider>
                  </ReportFormProvider>
                )}
              </LanguageContext.Consumer>
            </UiBaseProvider>
          </UserProvider>
        </LanguageProvider>
      </CustomizationProvider>
    </LayoutProvider>
  )
}

export default App
